module.exports = global["getGAEventTrackingCode"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?getGAEventTrackingCode!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./functions.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?getGAEventTrackingCode!../node_modules/exports-loader?getGAEventTrackingCode!../legacy/src/legacy/js/functions.js
// module id = 281
// module chunks = 0